import { createContext as o, useContext as t } from "react";
const e = o({
  showColumnSelection: !1,
  showNavigator: !1,
  showRowSelection: !1,
  uploadMode: "provisioning",
  useDeferredSchemaTableHeader: !1
}), a = e.Provider, s = () => t(e);
export {
  e as FeatureContext,
  a as FeatureProvider,
  s as useFeature
};
//# sourceMappingURL=FeatureContext.js.map
